/**
 * Represents an authenticated user as described by a decoded ID/access token.
 *
 * Lightweight wrapper for reading user information from token claims.
 * @remarks New instances of this class should NOT be constructed directly, use the static `fromToken` method instead.
 * This is in anticipation of supporting
 * @param tokenClaims A decoded access or ID token.
 */
export class UserPrincipal {
    constructor(props) {
        this.groups = [];
        this.roles = [];
        this.id = props?.id ?? null;
        this.groups = props?.groups ?? [];
        this.roles = props?.roles ?? [];
        this.name = props?.name ?? null;
        this.gpmUsername = props?.gpmUsername ?? null;
        this.email = props?.email ?? null;
    }
    /**
     * Create a UserPrincipal instance from decoded token claims.
     *
     * @param tokenClaims A decoded access or ID token.
     */
    static fromToken(tokenClaims) {
        return new UserPrincipal({
            id: tokenClaims?.oid ?? null,
            groups: tokenClaims?.groups ?? [],
            roles: tokenClaims?.roles ?? [],
            name: tokenClaims?.name ?? null,
            gpmUsername: tokenClaims?.gpmUsername ?? null,
            email: tokenClaims?.email ?? null,
        });
    }
    hasRole(role) {
        return this.roles.includes(role);
    }
    hasGroup(group) {
        return this.groups.includes(group);
    }
}
